module.exports = __webpack_public_path__ + "media/mascot/mascot1-57cdc2b9.png";